import axios from 'axios';
import { baseURL } from '@utils/endpoint';

export default {
  signed_url: (ids, bucket, path, payload) => axios.post(`${baseURL}/api/upload/${path}/signed_url/bucket/${bucket}/?company_id=${ids.company_id}&project_id=${ids.project_id}`, payload),
  set_bucket_compression: (cid) => axios.post(`${baseURL}/api/upload/compress/?company_id=${cid}`),
};
